// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__BEwKl","w100":"Loader_w100__YwDfs","overlay":"Loader_overlay__mtDaj","loader_logo":"Loader_loader_logo__+8Dps"};